<template>
    <layout>
        <div class="grade" style="box-sizing: border-box;padding: 20px;">
            <el-page-header @back="goBack" content="成绩对比"></el-page-header>
            <!-- <div style="display: inline-block;">
                <span class="year" @click="changeYear(index)" v-for="(item,index) in year" :key="index">{{ item }}</span>
            </div> -->
            <div style="width: 100%;height: 500px;" id="chart-container"></div>

        </div>
    </layout>
    
</template>
<script>
import * as echarts from "echarts";
import Http from "../apis/teach";
export default {

    data(){
        return{
            year:{2023:'2023年',2024:'2024年',2025:'2025年'},
            change_year:'2023'
        }
    },
    created(){
        setTimeout(() => {
            this.getChartData()
        }, 1000);
    },
    activated() {
        // 在组件激活时绑定点击事件
        const downloadBtn = document.getElementById('download-btn');
        if (downloadBtn) {
            downloadBtn.addEventListener('click', () => {
                if (this.myChart) {
                    const imgData = this.myChart.getDataURL({
                        pixelRatio: 2,
                        backgroundColor: '#fff'
                    });
                    const link = document.createElement('a');
                    link.href = imgData;
                    link.download = 'chart.png';
                    link.click();
                }
            });
        }
        
    },
    methods:{
        changeYear(year){
            this.change_year = year

            this.getChartData()

        },
        goBack() {
            this.$router.go(-1)
        },
        getChartData(){
            

            var dom = document.getElementById('chart-container');
            if (!dom) {
            console.error('未找到图表容器');
            return;
        }
            var myChart = echarts.init(dom);
            myChart.showLoading({
                text: '图表数据加载中...',
                color: '#409EFF',
                textColor: '#000',
                maskColor: 'rgba(255, 255, 255, 0.5)',
                zlevel: 0
            });
            var params = {}
            params.year = this.change_year
            Http.getTremGrade(params).then((res) => {
                if (!res.data || !Array.isArray(res.data.data)) {
                throw new Error('无效的图表数据格式');
            }
                myChart.hideLoading();
                this.chart(res.data)
            });
        },
        chart(item){
            var dom = document.getElementById('chart-container');
            var myChart = echarts.init(dom, null, {
                renderer: 'canvas',
                useDirtyRect: false
            });
            
            var option;

            option = {
                animationEasing: 'quadraticIn',
                title: {
                    text: '阶段成绩对比'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: item.termTexts
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                    saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: item.scoreRanges
                },
                yAxis: {
                    type: 'value'
                },
                series: item.data
            };

            console.log(11)
            option && myChart.setOption(option);

            window.addEventListener('resize', myChart.resize);
        }
    }
}
</script>
<style scoped>
    .year{
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        color: #ffffff;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        margin-right: 5px;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 4px;
        background-color: #409eff;
        margin-bottom: 20px;
    }
    .grade >>> .el-page-header{
        margin-bottom: 40px;
    }
</style>